<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="tableHeaders"
        :items="tableValues"
        multi-sort
        dense
        class="elevation-1"
      ></v-data-table>
      <download-csv
        class="btn btn-default"
        :data="rows"
        name="filename.csv">
      <v-btn type="submit" class="my-6" block tile>Download CSV</v-btn>
      </download-csv>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import reportutil from '../lib/reportUtil'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'insightreportrawtable',
  props: {
    title: String,
    rows: Array
  },
  components: {
    'downloadCsv': JsonCSV
  },
  data: () => {
    return {}
  },
  computed: mapState({
    tableHeaders: function (state) {
      let result = reportutil.getDefaultVuetifyTableHeader(this.tableValues)
      return result
    },
    tableValues: function (state) {
      return this.rows
    }
  })
}
</script>
